import { ComprovanteVoto } from '../models/comprovante-participante.model';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Comprovante } from '../models/comprovante.model';
import { EleicaoService } from 'src/app/services/eleicao.service';
import { Cargo } from '../models/cargo.model';

@Injectable({
  providedIn: 'root'
})
export class ComprovanteService {
  configHeader: any;

  constructor(
    private http: HttpClient,    
    protected eleicaoService: EleicaoService,
  ) { }

  public getComprovanteVotoPorIdEleitor(id: number, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.get(`${environment.url_api}/eleitor/${id}/comprovantes`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          }, err => {
            reject(err.error.message);
          }  
        )
    })
  }

  public getComprovantesPorIdEleicao(id: number, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.get(`${environment.url_api}/eleicoes/${id}/comprovantes`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          }, err => {
            reject(err.error.message);
          }  
        )
    })
  }
  validaCandidatosAVotar(idEleicao: number, comprovantes: Comprovante[], token: string) {
    return new Promise((resolve, reject) => {
      this.eleicaoService.getCargosByIdEleicao2(idEleicao, token).then((cargos: Cargo[]) => {
        let retorno = []
        for (const cargo of cargos) {
          let voto = false;
          for (const comprovante of comprovantes) {
            if(cargo.id == comprovante.cargoId){
              voto = true;
            }
          }
          if(!voto){
            retorno.push(cargo);
          }  
        } 
        resolve(retorno);        
      }).catch(err => {
        reject(err);
      })
  
    })
  }
}
